import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SdkInsightSectionComponent } from '../sdk-insight-section';

@Component({
  selector: 'app-sdk-privacy-disclosure',
  templateUrl: './sdk-privacy-disclosure.component.html',
  styleUrls: ['./sdk-privacy-disclosure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SdkPrivacyDisclosureComponent extends SdkInsightSectionComponent {
  data: any;

  constructor() {
    super();
    this._sdkInsightStateService.sdk$.subscribe(data => {
      this.data = data;
    });
  }
}
